import { render, staticRenderFns } from "./PrivacyPracticesForm.vue?vue&type=template&id=3f407332&scoped=true&"
import script from "./PrivacyPracticesForm.vue?vue&type=script&lang=js&"
export * from "./PrivacyPracticesForm.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPracticesForm.vue?vue&type=style&index=0&id=3f407332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f407332",
  null
  
)

export default component.exports